import { serializable, alias, primitive } from "serializr";
import moment from "moment";

export class Report {
  @serializable(alias("id", primitive()))
  id?: number;

  reportTemplateId?: number;

  @serializable(alias("content", primitive()))
  content?: string;

  @serializable(alias("case_detail_id", primitive()))
  caseDetailId?: number;

  @serializable(alias("direct_report_upload", primitive()))
  directReportUpload?: boolean;

  @serializable(alias("assignment_id", primitive()))
  assignmentId?: number;

  @serializable(alias("status", primitive()))
  status?: boolean;

  @serializable(alias("report_name", primitive()))
  reportName?: string;

  @serializable(alias("reported_doctor", primitive()))
  reportedDoctor?: string;

  @serializable(alias("created_at", primitive()))
  createdAt?: string;

  @serializable(alias("updated_at", primitive()))
  updatedAt?: string;

  getReportName() {
    let reportName = '';
    if(this.reportName && this.updatedAt) {
      return `${this.reportName}_${moment(this.updatedAt).format('DD MMM YYYY')}`
    }
  }
}